import { render, staticRenderFns } from "./operate-button.vue?vue&type=template&id=31d1e911&scoped=true"
import script from "./operate-button.vue?vue&type=script&lang=js"
export * from "./operate-button.vue?vue&type=script&lang=js"
import style0 from "./operate-button.vue?vue&type=style&index=0&id=31d1e911&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1e911",
  null
  
)

export default component.exports